export enum CardTypeEnum {
  Visa = 'visa',
  MasterCard = 'mastercard',
  AmericanExpress = 'amex',
  Maes = 'maes'
}
